import {get} from 'lodash';
import schema from './group_db';
import * as utils from "./utils";
import {edit} from './sample';
import i18n from 'src/i18n/index';
import debug from 'src/debug';

export function title(model) {
  return i18n.S(get(model, 'details.name')) || get(model, 'details.name_zh') || i18n.s('schema.group');
}

export const columns = utils.columnsFn(schema);

/**
 * @param {int} skip default 0
 * @param {int} limit default 20
 * @param {Array<{prop: String, desc: boolean}>} sort column name
 * @param {String} search query
 * @return {Promise<{total: Number, data: Array}>}
 */
export const list = utils.listFn('getGroups');
export const view = utils.viewFn('/admin/groups/:id');
export const read = utils.readFn('getGroupById', 'group_id');
export const create = utils.createFn('/admin/groups/create');

export {edit};

export function formActions(model, schema, readonly) {
  let temp = [];
  if (!readonly) {
    temp.push({
      label: i18n.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: e => (e.metaKey || e.ctrlKey) && e.keyCode === 13,
      action: utils.updateFn('updateGroup', 'group_id', [
        'status',
        'type',
        'tags',
        'details',
      ]),
    });
    temp.push({
      label: i18n.fr('action.duplicate'),
      class: 'btn-info',
      validation: true,
      action: utils.updateFn('duplicateGroup', 'group_id', [], null, null,
        utils.formActions.postprocess.redirect(result => `/admin/groups/${result.data.group_id}`)),
    });
    if (debug.DEBUG) {
      temp.push({
        label: i18n.s('action.delete') + ' [Del]',
        class: 'btn-danger',
        trigger: e => e.keyCode === 46,
        action: utils.formActions.delete('deleteGroupById', 'group_id', '/admin/groups'),
      });
    }
  }
  temp.push(utils.formActions.back);
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/group.js